import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { DashboardStats } from '@/components/features/statistics/DashboardStats';
import { useStatistics } from '@/lib/hooks';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';

export const Route = createFileRoute('/_auth/_admin/admin/')({
  component: AdminDashboardComponent,
});

function AdminDashboardComponent() {
  const { data, isLoading, isError, error } = useStatistics();
  console.log(data);

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Admin Dashboard"
        description="Overview of system statistics and performance"
      />

      <DashboardStats stats={data!} isLoading={isLoading} />

      <div className="grid gap-6 md:grid-cols-2">
        {/*<VolumeChart data={data || []} />*/}
        {/*<TransactionChart data={data} />*/}
      </div>
    </div>
  );
}
